export default __webpack_public_path__ + "static/media/health_check_female_En.fa96b98c.webp";